import React from 'react';
import PropTypes from 'prop-types';

import { StyledPageNumber, StyledPageNumberText } from './styles';

const PageNumber = ({ number, active = false, onClick }) => {
  return (
    <StyledPageNumber active={active} onClick={onClick}>
      <StyledPageNumberText>{number}</StyledPageNumberText>
    </StyledPageNumber>
  );
};

PageNumber.propTypes = {
  number: PropTypes.number,
  active: PropTypes.bool,
  onClick: PropTypes.func
};

export default PageNumber;
